export const EVENT_BADGE_TEMPLATE = 'EVENT_BADGE_TEMPLATE'
